"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = deprecated;

/**
 * Example:
 *      propTypes: {
 *          collapsable: deprecated(PropTypes.bool, 'Use "collapsible" instead.')
 *      }
 *
 * @param propType
 * @param explanation
 * @returns {validate}
 */
function deprecated(propType, explanation) {
  return function validate(props, propName, componentName) {
    if (typeof props[propName] !== 'undefined' && props[propName] !== null) {
      console.error("\"" + propName + "\" property of \"" + componentName + "\" has been deprecated.\n" + explanation);
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/util/deprecated.js
// module id = 428
// module chunks = 0